module.exports = __webpack_public_path__ + "img/icon_4_37.b213d04c.png";